<ng-container *transloco="let t">
<div (click)="!isReadOnly && onEditClicked()" class="hidden-when-mobile mb-4 p-3 d-flex text-gray-400" [ngClass]="{
  'btn': !isReadOnly,
  'btn-outline' : !isReadOnly,
  'btn-outline-dashed': reoItem.isValid && !isReadOnly ,
  'btn-outline-primary': reoItem.isValid && !isReadOnly,
  'btn-active-light-primary': reoItem.isValid && !isReadOnly,
  'btn-outline-danger': !reoItem.isValid && !isReadOnly,
  'btn-active-light-danger': !reoItem.isValid && !isReadOnly,
  'readonly-item': isReadOnly}">

  <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center mt-1 duotone-home-svg-mobile"
    [ngClass]="{'svg-icon-primary': !isReadOnly, 'svg-icon-danger': !reoItem.isValid}">
    <ng-template svgIconHost></ng-template>
  </span>
  <div class="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap align-items-center">
    <span class="fs-6 text-gray-600 d-block fw-bold"><strong>{{reoItem.address}}</strong></span>
    <div class="d-flex justify-content-end align-items-center">
      <label class="form-label line-item-text px-4 mt-3">{{reoItem.reoOwners}}</label>
      <label class="form-label line-item-text px-4 mt-3">{{ t('wizard.reo.propertyTypeLabel') }} {{propertyTypeName}}</label>
      <label class="form-label line-item-text px-4 mt-3">{{ t('wizard.reo.propertyValueLabel') }} {{reoItem.propertyValue | currency}}</label>

      <div class="align-self-center text-nowrap">
        @if (!isReadOnly) {
          <div class="d-flex" style="margin-top: 4px;">
            <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              (click)="onDeleteClicked($event)">
              <span class="svg-icon svg-icon-3">
                <duotone-trash-svg-icon></duotone-trash-svg-icon>
              </span>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div (click)="!isReadOnly && onEditClicked()" class="hidden-when-not-mobile mb-4 p-3 d-flex text-gray-400" [ngClass]="{
  'btn': !isReadOnly,
  'btn-outline' : !isReadOnly,
  'btn-outline-dashed': reoItem.isValid && !isReadOnly ,
  'btn-outline-primary': reoItem.isValid && !isReadOnly,
  'btn-active-light-primary': reoItem.isValid && !isReadOnly,
  'btn-outline-danger': !reoItem.isValid && !isReadOnly,
  'btn-active-light-danger': !reoItem.isValid && !isReadOnly,
  'readonly-item': isReadOnly}">

  <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center mt-1 duotone-home-svg-mobile"
    [ngClass]="{'svg-icon-primary': !isReadOnly, 'svg-icon-danger': !reoItem.isValid}">
    <ng-template svgIconHost></ng-template>
  </span>
  <div style="width: 100%;">
    <div class="d-flex justify-content-between mx-2">
      <span class="fs-4 text-gray-600 d-block fw-bold mt-3"><strong>{{reoItem.address}}</strong></span>
      <div class="align-self-center text-nowrap">
        @if (!isReadOnly) {
          <div class="d-flex" style="margin-top: 4px;">
            <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              (click)="onDeleteClicked($event)">
              <span class="svg-icon svg-icon-3">
                <duotone-trash-svg-icon></duotone-trash-svg-icon>
              </span>
            </a>
          </div>
        }
      </div>
    </div>
    <div class="text-start mt-3 px-2">
      @if (reoItem.reoOwners) {
        <div>
          <label class="form-label line-item-text" style="min-width: 8rem;"> {{ t('wizard.reo.borrowerLabel') }} </label>
          <span> {{reoItem.reoOwners}} </span>
        </div>
      }
      @if (propertyTypeName) {
        <div>
          <label class="form-label line-item-text" style="min-width: 8rem;"> {{ t('wizard.reo.propertyTypeLabel') }} </label>
          <span> {{propertyTypeName}} </span>
        </div>
      }
      @if (reoItem.propertyValue) {
        <div>
          <label class="form-label line-item-text" style="min-width: 8rem;"> {{ t('wizard.reo.propertyValueLabel') }} </label>
          <span> {{reoItem.propertyValue | currency: 'USD':true:'2.0' }} </span>
        </div>
      }
    </div>
  </div>
</div>
</ng-container>
